import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/PageShell";

const BENEFITS = [
  "Priority sourcing across aircraft, yacht and bullion desks",
  "Preferential empty-leg access before public release",
  "Vistacion member dashboard access",
  "Invitations to Club events and private previews",
  "A single point of contact: Marcelle and the Aerovista team",
];

export const Membership = () => (
  <section id="membership" data-testid="membership-section" className="py-24 lg:py-32 bg-obsidian border-t border-white/5 scroll-mt-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="lg:col-span-6">
        <SectionHeading overline="Membership by application" title="For those who travel and invest without compromise">
          No flight commitment. No prepaid balance. Just priority access to every desk and preferential terms across the Aerovista ecosystem.
        </SectionHeading>
        <ul className="space-y-3 -mt-6">
          {BENEFITS.map((b) => (<li key={b} className="flex items-start gap-3 text-sm text-white/70"><Check size={14} className="text-gold mt-1 shrink-0" />{b}</li>))}
        </ul>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }}
                  className="lg:col-span-6 bg-surface border border-gold/40 rounded-sm p-8 lg:p-12 flex flex-col justify-between" data-testid="membership-apply-card">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">How it works</p>
          <ol className="mt-6 space-y-5 text-sm text-white/70">
            {["Tell us how you travel and what you are looking to acquire.", "Marcelle reviews your application and comes back personally within 2 hours during business hours.", "Terms are agreed privately and tailored to how you will use the Club."].map((step, i) => (
              <li key={step} className="flex gap-4"><span className="font-serif text-2xl text-gold leading-none">{i + 1}</span><span className="pt-1">{step}</span></li>
            ))}
          </ol>
        </div>
        <div className="mt-10">
          <Link to="/enquire/membership" data-testid="membership-apply-button" className="inline-flex items-center gap-3 bg-gold text-black text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm hover:bg-gold-light transition-colors">
            Apply for membership <ArrowRight size={14} />
          </Link>
          <p className="mt-5 text-[11px] text-white/30">Membership terms are confirmed personally and are not published. Prefer flights on account? See the <a href="#jet-account" className="text-gold hover:text-gold-light" data-testid="membership-jet-account-link">Jet Account</a>.</p>
        </div>
      </motion.div>
    </div>
  </section>
);
